<template>
  <a-button
    size="small"
    type="link"
    :id="`download-import-template-${type}`"
    @click="handleDownload"
  >
    {{ loading ? "Descargando" : "Descargar" }}
  </a-button>
</template>

<script>
import { defineComponent } from "vue";

import { downloadFile } from "@/app/shared/utils/file";

export default defineComponent({
  props: {
    type: {
      required: true,
      type: String,
      validator: (value) => ["contacts", "product"].includes(value),
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async handleDownload() {
      try {
        this.loading = true;
        const blob = await this.$store.dispatch("downloadTemplateByType", this.type);
        downloadFile(blob, `${this.type}-template.zip`);
      } catch {
        this.$notification.error({
          message: "No se pudo descargar la plantilla",
        });
      } finally {
        this.loading = false;
      }
    },
  },
});
</script>
